import React from 'react';

const MySearchIcon = (props) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"  {...props}>
      <g clipPath="url(#clip0_815_3)">
        <circle cx="7" cy="7" r="6.5" stroke="#9A9A9A"/>
        <rect x="11.7071" y="11" width="7.86678" height="1" transform="rotate(45 11.7071 11)" fill="#9A9A9A"/>
      </g>
      <defs>
        <clipPath id="clip0_815_3">
          <rect width="17.4" height="17.4" fill="white"/>
        </clipPath>
      </defs>
    </svg>

  );
};

export default MySearchIcon;
